import { useCallback, useEffect, useState } from 'react'
import { getOperationalReport } from '../application/get-operational-report'
import type { OperationalReport } from '../domain/operational-report'
import { reports } from '../wiring'

const useOperationalReport = () => {
	const [report, setReport] = useState<OperationalReport | null>(null)
	const [isLoading, setIsLoading] = useState(true)

	const load = useCallback(async (): Promise<void> => {
		setIsLoading(true)
		try {
			const result = await getOperationalReport(reports)
			setReport(result)
		} finally {
			setIsLoading(false)
		}
	}, [])

	useEffect(() => {
		void load()
	}, [load])

	return { report, isLoading, reload: load }
}

export { useOperationalReport }
